module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/home/door-open-da88d3f7e107fe6073916c680b4b4d7f.svg";